import type { Page } from '../../types';

const shareObjectiveWithTeam: Page[] = [
  {
    pageType: 'question',
    title: 'Share objectives with your team',
    name: 'share-objective-with-my-team',
    questions: [
      {
        questionType: 'select',
        title: 'How would you like to share your objectives?',
        name: 'objective-sharing-method',
        hintOption: 'Select an option',
        options: [
          'I will share them myself',
          {
            option: 'Please share them for me',
            questions: [
              {
                questionType: 'textarea',
                textRows: 20,
                title:
                  "Please enter your team members' email addresses below to share your objectives with them.",
                name: 'team-member-email-addresses',
                hint: 'You can separate emails using a comma, a space, or by putting each email on a new line.',
                emailList: true,
                rules: {
                  required: true,
                },
              },
              {
                questionType: 'hidden',
                title: 'Share status',
                name: 'share-status',
                actionButtonText: 'Send emails',
                actionType: 'scsObjectivesShare',
                rules: {
                  required: true,
                },
                errorMessages: {
                  required: 'Objectives have not yet been shared',
                },
              },
            ],
          },
          'Not applicable',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default shareObjectiveWithTeam;
